import React, { Component, Ref } from 'react'
import { debounce } from 'lodash'
import './Textarea.less'
import { Box } from 'front-end/src/components'
import { css } from '@emotion/react'

type onChangeEventCallback = (
  val: string,
  event?: React.ChangeEvent<HTMLTextAreaElement>
) => void

export interface ITextareaProps {
  placeholder?: string
  fullWidth?: boolean
  onChange?: onChangeEventCallback
  debouncedOnChange?: onChangeEventCallback
  inputRef?: Ref<HTMLTextAreaElement>
  id?: string
  disabled?: boolean
  value?: string
  title?: string
  rows?: number
  defaultValue?: string
}

// TODO refactor to TS
export default class Textarea extends Component<ITextareaProps> {
  static defaultProps = {
    fullWidth: false
  }
  handleOnChangeDebounced: onChangeEventCallback

  onChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    e.preventDefault && e.preventDefault()
    const value = e.target.value
    e.persist()
    if (this.props.onChange) {
      this.props.onChange(value, e)
    }
    if (this.props.debouncedOnChange) {
      this.handleOnChangeDebounced(value, e)
    }
  }

  componentDidMount() {
    if (this.props.debouncedOnChange) {
      this.handleOnChangeDebounced = debounce(this.props.debouncedOnChange, 500)
    }
  }

  render() {
    const {
      props: {
        placeholder,
        fullWidth,
        disabled,
        inputRef,
        debouncedOnChange,
        id,
        onChange,
        rows,
        value,
        ...passThroughProps
      }
    } = this
    const cssClasses = ['Textarea']
    if (fullWidth) {
      cssClasses.push('fullWidth')
    }

    const dynamicProps = {
      [onChange ? 'value' : 'defaultValue']: value
    }

    return (
      <Box
        css={css`
          textarea {
            &:active,
            &:focus {
              border-color: var(--chakra-colors-buttonPrimary-default);
            }
          }
        `}
      >
        <textarea
          ref={inputRef}
          onChange={this.onChange}
          className={cssClasses.join(' ')}
          placeholder={placeholder}
          id={id}
          disabled={disabled}
          rows={rows}
          {...dynamicProps}
          {...passThroughProps}
        />
      </Box>
    )
  }
}
